import {
  Container,
  Coords,
  RenderPosition,
  RenderStyle,
} from '../../shared/interfaces';

export interface MessengerScreenConfig {
  isMobile: boolean;
}

export interface MessengerConfig {
  renderAs: RenderStyle;
  position: RenderPosition;
  marginY: number;
  syncEliseAI?: boolean;
  screen: MessengerScreenConfig;
  [key: string]: unknown;
}

export abstract class BaseMessenger extends Container {
  protected config: MessengerConfig;
  protected elId: string;
  protected element: HTMLDivElement | null;

  private responsiveMarginsQuery: MediaQueryList | null;
  private responsiveMarginsListener:
    | ((event: MediaQueryListEvent) => void)
    | null;

  constructor(elId: string) {
    super();

    this.config = {} as MessengerConfig;
    this.elId = elId;
    this.element = null;
    this.responsiveMarginsQuery = null;
    this.responsiveMarginsListener = null;
  }

  onOpen() {
    this.element?.classList.add('is-show');
  }

  onClose() {
    this.element?.classList.remove('is-show');
  }

  onToggle() {
    this.element?.classList.toggle('is-show');
  }

  onTooltipDisplay(_coords: Coords | null, _label: string) {}

  setMargins() {
    if (!this.element) return;

    this.detachResponsiveMargins();

    const matchMobile = window.matchMedia('(max-width: 720px)');
    const applyMargins = (isMobile: boolean) => {
      if (!this.element) return;

      const offset = isMobile ? '0' : '10px';
      this.element.style[this.config.position] = offset;
      this.element.style.bottom = offset;
    };

    applyMargins(matchMobile.matches);

    const listener = (event: MediaQueryListEvent) => {
      applyMargins(event.matches);
    };

    matchMobile.addEventListener('change', listener);

    this.responsiveMarginsQuery = matchMobile;
    this.responsiveMarginsListener = listener;
  }

  protected detachResponsiveMargins() {
    if (this.responsiveMarginsQuery && this.responsiveMarginsListener) {
      this.responsiveMarginsQuery.removeEventListener(
        'change',
        this.responsiveMarginsListener
      );
    }

    this.responsiveMarginsQuery = null;
    this.responsiveMarginsListener = null;
  }
}
